"use client"
import React, { useEffect, useRef, useState } from 'react';
import SecuritySection from '../SecuritySection/SecuritySection';
import PredictAttackSection from '../PredictAttackSection/PredictAttackSection';
import Testimonial from '../Testimonial/Testimonial';
import SecurityBubble from '../SecurityBubble/SecurityBubble';
import LevelUpAndTrustSection from '../LevelUpAndTrustSection/LevelUpAndTrustSection';
import { motion, useInView } from "framer-motion";
import BreathingGradient from '../HomeAnimation';

function HomePage({ blok }) {
  const getStartedBtnClass = `bg-[#5A27E7] text-white px-4 py-2 rounded hover:bg-[#483889] 
    transition duration-150 rounded text-[18px] lg:h-[80px] lg:w-[300px] lg:text-[24px]`;
  const [screenWidth, setScreenWidth] = useState(0);
  const levelUpRef = useRef(null);

  const handleScrollToLevelUp = () => {
    levelUpRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };



  useEffect(() => {
    // Set initial width
    setScreenWidth(window.innerWidth);

    // Update width on resize
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <div className=" flex flex-col min-h-screen mx-auto w-full">
      <div
        className="relative w-full h-auto bg-custom-bg bg-repeat bg-top overflow-hidden lg:bg-cover flex flex-col items-center"
        style={{
          backgroundSize: screenWidth > 1500 ? '120%' : 'cover',
        }}
      >
        <div className="max-w-7xl relative">
          {/* <div className='absolute  w-full h-screen z-10'> */}
          <BreathingGradient/>
          {/* </div> */}
          <div className="relative mt-[-6%] max-w-[1920px] mx-auto px-4 sm:px-8 lg:px-16 pt-20 z-20">
            <div className="font-aileron py-16 md:py-24 lg:py-32 text-center font-bold">
              <h1 className="text-[28px] xs:text-[34px] lg:text-[80px] bg-gradient-to-r from-[#4A3697] via-[#5828E0] to-[#473887] inline-block text-transparent bg-clip-text leading-[112%] md:leading-[125%]">{blok.titleText1}</h1>
              <h2 className="text-[32px] xs:text-[36px] lg:text-[96px] lg:mt-[-20px] bg-gradient-to-r from-[#4A3697] via-[#5828E0] to-[#473887] inline-block text-transparent bg-clip-text">{blok.titleText2}</h2>
            </div>

            {/* Button */}
            <div className="text-center mt-[-50px] lg:mb-32">
              <button onClick={handleScrollToLevelUp} className={getStartedBtnClass}>
                {blok.buttonText1}
              </button>
            </div>

            {/* Subtitle */}
            <h6 className="text-[18px] sm:text-[20px] lg:text-[36px] !text-[#48378C] font-bold text-center mt-10 px-[16px] lg:px-0 pb-5 lg:pb-0">
              {blok.titleText3}
            </h6>
            <p className="w-[90%] sm:w-[80%] lg:w-[60%] mx-auto text-center text-sm sm:text-lg lg:mt-4">
              {blok.subtitleText3}
            </p>

            {/* Press Release Button */}
            <div className="flex justify-center items-center mt-10">
              <a href="/media-coverage">
                <button className="bg-[#E56717] text-white px-6 py-3 rounded-md hover:bg-[#D76F1F] transition duration-150">
                  {blok.buttonText3}
                </button>
              </a>
            </div>

            {/* Award Image */}
            <motion.div
              ref={ref}
              className="flex justify-center items-center mt-10"
              initial={{ x: -100, opacity: 0 }}
              animate={isInView ? { x: 0, opacity: 1 } : {}}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              <img src={blok.image3.filename} alt="Award" className="w-[150px] sm:w-[200px] lg:w-[300px]" />
            </motion.div>
          </div>

        </div>
        <SecurityBubble blok={blok} />
        <SecuritySection screenWidth={screenWidth} blok={blok}/>
      </div>

      {/* Additional Sections */}
      <div
        className="relative z-20 bg-white lg:mt-[-100px] p-0"
        style={{
          backgroundImage: `url('/images/PredictAttackSection-bg.png')`,
          backgroundSize: "110%",
          backgroundPosition: "right top",
          backgroundRepeat: "repeat",
          minHeight: "800px",
          clipPath: screenWidth >= 1500 ? "polygon(0 110px, 100% 0, 100% 100%, 0 100%)" : "none",

        }}
      >
        <div className="lg:px-32 lg:pt-32 space-y-10">
          <PredictAttackSection screenWidth={screenWidth} accordian={blok.Accordian}/>
          <Testimonial screenWidth={screenWidth} blok={blok}/>
        </div>

        <LevelUpAndTrustSection levelUpRef={levelUpRef} blok={blok}/>

      </div>
    </div>

  );
}

export default HomePage;